import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Table, { Column } from "../../../../Components/Tables/Table";
import { PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import {
  inboundASNCheckInData,
  inboundReturnCheckInCompleteData,
  inboundReturnCheckInData,
} from "../../../../Data/testData";
import { Dropdown } from "react-bootstrap";
import { asnAdvanceFilter } from "../../Check-In/CheckIn.type";
import { SubmitHandler, useForm } from "react-hook-form";
import PageHeader from "../../../../Layout/PageHeader";
import Tabs from "../../../../Shared/Tab/Tab";
import OffCanvas from "../../../../Components/FormTag/OffCanvas";
import FormSelect from "../../../../Components/FormTag/FormSelect";
import { asnDate, eta } from "../../../../Data/dropdownDataList";
import InputFiled from "../../../../Components/FormTag/InputFiled";
import { ALPHANUM_SPACE_REGEX } from "../../../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../../../Shared/Helper/ValidationMessage";
import ImportLayout from "../../../../Layout/ImportLayout";
import ExportLayout from "../../../../Layout/ExportLayout";
import CommonModal from "../../../../Components/Modals/CommonModal";


export default function ReturnCheckinOverview() {
  const pageName = "Check In";
  const navigation = useNavigate();
  const [showModalForImportAndExport, setShowModalForImportAndExport] =
  useState({
    importModal: false,
    exportModal: false,
  });
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShow(!show);   

  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());

  const [isShowCanvas, setShowCanvas] = useState(false);

  const handleSelectedRowsChange = (newSelectedRows: Set<number>) => {
    setSelectedRows(newSelectedRows);
  };
  const columns: Column[] = [
    {
      name: "Return #",
      selector: (row: { ASN: string }) => (
          <span className="cursor-pointer text-primary">
              {row.ASN}
          </span>
      ),
    },
    {
      name: "Supplier ",
      selector: (row: { Supplier: string }) => row.Supplier,
    },
    {
      name: "Tracking # ",
      selector: (row: { Tracking: string }) => "-",
    },
    {
      name: "Door",
      selector: (row: { Door: string }) => "-",
    },
    {
      name: "ATA",
      selector: (row: { ATA: string }) => row.ATA,
    },
    {
      name: "Status",
      selector: (row: { Status: string }) => {
        return row.Status === "Check in Complete" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue">
            Check-in Complete
          </span>
        ) : row.Status === "Ready to Check in" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue">
            Ready to Check-in
          </span>
        ) : (
          <></>
        );
      },
    },
    {
      name: <PlusCircle />,
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelEditAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelInactiveAction(row)}
            >
              Inactive
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={handelDeleteAction}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];
  const handelEditAction = (data: any) => {};
  const handelInactiveAction = (data: any) => {};
  const handelDeleteAction = (data: any) => {};

  // Filter and count the "Ready to Check in" entries
  const readyToCheckInData = inboundASNCheckInData.filter(
    (entry) => entry.Status === "Ready to Check in"
  );
  const readyToCheckInCount = readyToCheckInData.length;
  const sortedReadyToCheckInData = [
    ...readyToCheckInData,
    ...inboundASNCheckInData.filter(
      (entry) => entry.Status !== "Ready to Check in"
    ),
  ];

  //Filter and count the "Check-in Complete" entries
  const checkInCompleteData = inboundASNCheckInData.filter(
    (entry) => entry.Status === "Check in Complete"
  );
  const checkInCompleteCount = checkInCompleteData.length;
  const sortedCheckInCompleteData = [
    ...checkInCompleteData,
    ...inboundASNCheckInData.filter(
      (entry) => entry.Status !== "Check in Complete"
    ),
  ];

  const handleRowClick = (data: any) => {
    navigation(`/inbound/returns/checkin/details/${data.ASN}`);
  };
  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  const tabs = [
    {
      order: 0,
      label: "Ready to Check-in | " + inboundReturnCheckInData.length,
      content: (
        <Table
        customClassName="sph-table-color"
          columns={columns}
          data={inboundReturnCheckInData}
          pagination={{
            recordsPerPage: 15,
            totalRecords: inboundReturnCheckInData.length,
            onCurrentPageChange: onCurrentPageChange
          }}
          handleRowClick={handleRowClick}
          onSelectedRowsChange={handleSelectedRowsChange}
        />
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Check-in Complete | " + inboundReturnCheckInCompleteData.length,
      content: (
        <Table
        customClassName="sph-table-color"
          columns={columns}
          data={inboundReturnCheckInCompleteData}
          pagination={{
            recordsPerPage: 15,
            totalRecords: inboundReturnCheckInCompleteData.length,
            onCurrentPageChange: onCurrentPageChange
          }}
          handleRowClick={handleRowClick}
        />
      ),
      visibility: true,
      status: false,
    },
  ];
  const handleGlobalFilter = () => {
   setShowCanvas(!isShowCanvas);
  };
  const handleGlobalSearch = () => {
   
   };
  const headerChildren = (
    <>
      <div className="d-flex align-items-center gap-1">
        <Dropdown>
          <Dropdown.Toggle
            className="btn bg-white text-dark dropdown-toggle"
            id="dropdown-basic"
          >
            Saved Filter
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
              One line count
            </Dropdown.Item>
            <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
              Special count
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );

  const [asnAdvanceFilterData, setAsnAdvanceFilterData] =
    useState<asnAdvanceFilter>(new asnAdvanceFilter());
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<asnAdvanceFilter>({
    defaultValues: asnAdvanceFilterData,
  });
  const nextData: SubmitHandler<asnAdvanceFilter> = (data) => {
    setAsnAdvanceFilterData(data);
    handleGlobalFilter();
  };
  return (
    <>
      <PageHeader
        addUrl="/inbound/returns/checkin/add"
        listUrl="/inbound/returns/checkin"
        name={pageName}
        nameButtonStatus={selectedRows.size > 0 ? true : false}
         handleGlobalFilter={handleGlobalFilter}
         handleGlobalSearch={handleGlobalSearch}
        setShowModalForImportAndExport={setShowModalForImportAndExport}
        showModalForImportAndExport={showModalForImportAndExport}
      />

      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div>
        <Tabs tabs={tabs} />
      </div>
      <div className="inbound-CheckIn-Table-Main-Div"></div>
      <OffCanvas
        show={isShowCanvas}
        handleClose={handleGlobalFilter}
        title="Advance Filter"
        headerChildren={headerChildren}
      >
        <>
          <div className="offcanvas-body offcanvas-height custom-scrollbar">
            <form>
              <div className="">
                <div>
                  <label>ASN Date</label>
                  <div>
                    <FormSelect
                      tabIndex={1}
                      name="asnDate"
                      control={control}
                      optionList={asnDate}
                      className="form-control p-0"
                      placeholder="Select"
                      isSearchable={true}
                    />
                  </div>
                </div>
                <div className="my-3">
                  <label>Supplier</label>
                  <div>
                    <InputFiled
                      tabIndex={2}
                      type="text"
                      register={register}
                      name="supplier"
                      errors={errors.supplier}
                      className="form-control"
                      placeholder="Enter supplier"
                      pattern={{
                        type: ALPHANUM_SPACE_REGEX,
                        message: PATTERN_ERR_MSG,
                      }}
                    />
                  </div>
                </div>
                <div>
                  <label>ETA</label>
                  <div>
                    <FormSelect
                      tabIndex={1}
                      name="eta"
                      control={control}
                      optionList={eta}
                      className="form-control p-0"
                      placeholder="Select"
                      isSearchable={true}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="offcanvs-footer d-flex justify-content-end  px-0 border-top pt-3">
            <button
              className="btn offcanvas-close-btn px-4 mx-2 "
              onClick={handleGlobalFilter}
            >
              Clear
            </button>
            <button
              className="btn offcanvas-apply-btn px-4 px-2 "
              onClick={handleSubmit(nextData)}
            >
              Apply
            </button>
          </div>
        </>
      </OffCanvas>
      <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
    </>
  );
}
